<p>
  <a [routerLink]="'privacy'" [target]="'_blank'">{{
    "dialogs.agreementUpdated.privacyPolicyLinkText" | translate
  }}</a>
  {{ "dialogs.agreementUpdated.and" | translate }}
  <a [routerLink]="'contract'" [target]="'_blank'">{{
    "dialogs.agreementUpdated.contractTermsLinkText" | translate
  }}</a>
  {{ "dialogs.agreementUpdated.text" | translate }}
</p>
